export default "__VITE_ASSET__CkIFGeVy__"